import axios from 'axios'
import Vue from 'vue'

const DEFAULT_API_BASE_URL = 'https://backaws.motocasystems.com.br'

const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_AXIOS_URL || DEFAULT_API_BASE_URL,
})

axiosIns.interceptors.request.use(
  config => {
    const accessToken = localStorage.getItem('accessToken')

    if (accessToken) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${accessToken}`,
      }
    }

    return config
  },
  error => Promise.reject(new Error(error)),
)

axiosIns.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      // Importação dinâmica para evitar o ciclo
      const router = require('@/router').default
      if (router.currentRoute.path !== '/login') {
        router.push('/login')
      }
    }

    // if (error?.response && error?.response?.status === 403) {
    //   Vue.swal({
    //     title: 'Acesso negado',
    //     text: error.response.data.data.message || 'Você não tem permissão para acessar este recurso.',
    //     icon: 'error',
    //     showConfirmButton: true,
    //   })
    // }

    return Promise.reject(error)
  },
)

Vue.prototype.$http = axiosIns

export default axiosIns
